import React, { Component } from 'react'
import { connect } from 'react-redux'
import Gauge from './gauge/gauge'
import CaloriasNivel from './calorias_nivel'
import PesoIdeal from './peso_ideal'
import CaloriasObjetivo from './calorias_objetivos'
import './result.css'
import Mpm from './mpm'
import Sendyform from './sendyform/sendyform'
import FooterInfo from '../../components/footer/footerInfo'
import Macronutrientes from './macronutrientes'
import Nivelagua from './nivelagua'
import { createRef } from 'react'
import moment from 'moment'
import Nutrition from './nutrition'
import logo from '../../assets/img/logoHeader.svg'
class Results extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sendyform: createRef(),
      userRestricId: localStorage.getItem('userRestricId'),
    }
    this.toDown = this.toDown.bind(this)
    this.newCalc = this.newCalc.bind(this)
  }
  componentDidMount() {
    this.props.calculateResult()
    localStorage.setItem('dateCalc', moment().add(90, 'days').format())
  }
  newCalc() {
    localStorage.removeItem('dataCalc')
    localStorage.removeItem('venc')
    localStorage.removeItem('dateCalc')
    window.location.reload()
  }
  toDown() {
    this.state.sendyform.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
  render() {
    return (
      <>
        <div
          id="init-page"
          className="container"
          style={{ paddingTop: '3rem' }}
        >
          {/* <button
            style={{
              margin: '30px auto',
              backgroundColor: 'transparent',
              color: 'white',
              textTransform: 'uppercase',
              marginTop: '16px',
              marginBottom: '30px',
              border: '2px solid #bcec4d;',
            }}
            onClick={this.toDown}
          >
            Quiero aprender a entrenar de forma efectiva
          </button> */}
          <div className="logo-container">
            <img className="logo-image" src={logo} alt="fullmusculo-logo" />
          </div>
          <div className="row" style={{ margin: 'auto' }}>
            <div style={{ margin: '0px auto 3rem' }}>
              <h1 style={{ textAlign: 'center', margin: '0px' }}>
                Calculadora de calorias y macronutrientes
              </h1>
              <h4 style={{ textAlign: 'center', margin: '0px' }}>
                Tus resultados
              </h4>
              <div id="confirm-email">
                <i className="fas fa-envelope email-icon"></i>
                <div>
<p>
                  <strong>{this.props.state.name}</strong> aqui están tus
                  resultados y te he enviado un email con mis mejores consejos
                  para aplicar esto en tu alimentación.
                </p>
                <p>
                  Si no encuentras el email revisa en spam o correo no deseado
                </p>
                </div>
                
              </div>
              
            </div>
            <div className="col-lg-6">
              <Gauge />
              <PesoIdeal />
            </div>
            <div
              className="col-lg-6"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <CaloriasNivel />
              <CaloriasObjetivo />
              {this.props.state.sexo === 'hombre' ? <Mpm /> : null}
            </div>
            <div className="col-12">
              <Macronutrientes />
            </div>
            <div className="col-12">
              <Nivelagua />
            </div>
          </div>
          <button
            style={{
              margin: '0 auto',
              backgroundColor: 'transparent',
              color: 'white',
              textTransform: 'uppercase',
              marginTop: '16px',
              marginBottom: '30px',
              border: '2px solid #bcec4d',
            }}
            onClick={this.newCalc}
          >
            Volver a calcular
          </button>
        </div>

        <div ref={this.state.sendyform} style={{ backgroundColor: '#1a1a1a' }}>
          <Nutrition></Nutrition>
          <FooterInfo />
        </div>
      </>
    )
  }
}
const mapStateToProps = (state) => ({
  state: state,
})
const mapDispatchToProps = (dispatch) => ({
  calculateResult() {
    dispatch({
      type: 'GENERATE_RESULT',
    })
  },
  changePage(page) {
    dispatch({
      type: 'CHANGE_PAGE',
      page,
    })
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(Results)
